import { styled } from '@mui/material/styles'

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  background: theme.palette.background.default,
}))

export const View = styled('div')({
  display: 'flex',
  flex: 1,
})

export const NavigationWrapper = styled('aside')(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.background.paper,
  //Added
  //flexDirection: 'column',
  //width: '250px',
  //minWidth: '250px',
  //borderRight: `1px solid ${theme.palette.divider}`,
  //padding: '20px 0px',

  '& .list': {
    width: 250,
    color: theme.palette.grey[500], //theme.GREY
    fontSize: 16,
  },

  '& .active': {
    color: theme.palette.primary.main, //theme.PRIMARY
    background: theme.palette.primary.light, //theme.PRIMARY_80
  },
}))

export const ContentArea = styled('main')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  margin: '1.125rem 1.25rem 0',
  height: 'unset',
  borderRadius: theme.shape.customBorderRadius.main,
}))
